<template>
  <div class="wrapper">
    <h3>Button - Plain - Primary</h3>
    <p>
      <gl-button :primary="true">Button</gl-button>
      <gl-button :primary="true" icon-pre="user">Button</gl-button>
      <gl-button :primary="true" icon-post="user">Button</gl-button>
      <gl-button :primary="true" icon-pre="user" icon-post="user"
        >Button</gl-button
      >
    </p>
    <h3>Button - Raised - Primary</h3>
    <p>
      <gl-button :raised="true" :primary="true">Button</gl-button>
      <gl-button :raised="true" :primary="true" icon-pre="user"
        >Button</gl-button
      >
      <gl-button :raised="true" :primary="true" icon-post="user"
        >Button</gl-button
      >
      <gl-button :raised="true" :primary="true" icon-pre="user" icon-post="user"
        >Button</gl-button
      >
    </p>
    <h3>Toggle Switch</h3>
    <p>
      <gl-switch>Switch</gl-switch>
    </p>
    <h3>Chip</h3>
    <p>
      <gl-chip primary>Chip</gl-chip>
      <gl-chip primary deletable>Deletable</gl-chip>
    </p>
    <h3>Calendar (Date)</h3>
    <p>
      <gl-input-calendar
        :value.sync="calendarValue"
        min="20190115"
        max="20190215"
        required
      />
    </p>
    <h3>Calendar (Month)</h3>
    <p>
      <gl-select-month
        :value.sync="month"
        dateFrom="20190115"
        dateTo="20191001"
      />
    </p>
    <h3>Error Text</h3>
    <p>
      <gl-error-text :errors="errors" />
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      calendarValue: '20190115',
      month: undefined,
      errors: ['some error', 'another error'],
    }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 32px;
}
</style>
